/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useSnackbar from 'src/hooks/useCustomSnackbar';
// @mui
import {
    Container,
    Tab,
    Box,
    Tabs,
    Grid,
    Card,
    IconButton,
    Typography,
    Button,
    MenuItem,
    FormControl,
    Popover,
    Popper,
    Grow,
    Paper,
    MenuList,
    ClickAwayListener,
    Tooltip,
    Zoom,
    Divider,
    Dialog,
    DialogTitle,
    DialogActions,
    Alert,
    AlertTitle,
    Stack,
    Chip,
    Skeleton,
    useTheme,
    useMediaQuery
} from '@mui/material';
// components
import { fetchMergeTagValueForLeads, fetchMergeTagValueForTreatments } from 'src/redux/slices/mergeTags';
import { setOpenCallScriptFromLeadPage, getCallScriptSection } from 'src/redux/slices/callScript';
import { setCurrentTreatmentDataGlobal } from 'src/redux/slices/multiTreatment';
import LeadTemplate from 'src/pages/dashboard/LeadTemplate';
import { HeaderBreadcrumbs, Label, Iconify, LeadDetailsPersonalDetails } from 'src/components';
import {
    EditDialogPopup,
    AddReminderPopup,
    SwitchUserPopup,
    ConsentBuilderPopUp,
    AssignTaskPopup,
    ArchivedLeadPopUp,
    AddNotePopup,
} from 'src/components/dialogPopUp';

import SendFormsDialog from 'src/components/dialogPopUp/SendFormsDialog';
import useFormsFlags from 'src/hooks/useFormsFlags';
import useFeaturePermission from 'src/hooks/useFeaturePermission';
import useDashboardHomePath from 'src/hooks/useDashboardHomePath';
import { menuCrumbsForOrigin } from 'src/constants/tableMenuLabels';
import { callApi } from 'src/utils/apiCall';
import { useSettingsContext } from 'src/components/settings/context';
import { AutocompleteTags } from 'src/components/AutoComplete';
import { OpenPayment } from 'src/components/fullScreenPopUps';
import { AssignUserAvatar } from 'src/components/custom-avatar';
import { NormalLoading } from 'src/components/loading';
import LeadBucketExplainer from 'src/components/LeadBucketExplainer';
// sections
import { AccountSocialLinks } from 'src/sections/@dashboard/user/account';
import {
    LeadDetailTasks,
    Activities,
    TreatmentsDetails,
    OverView,
    PaymentRefunds,
    MetaSource,
    Communication,
    ConsultationRecordings,
    LeadDetailClinCheck,
    LeadFormsTab,
    BackfillPreviewModal,
} from 'src/sections/@dashboard/leadDetail';
import { ActiveTreatmentProvider } from 'src/sections/@dashboard/leadDetail/ActiveTreatmentContext';
import LeadPinControl from 'src/sections/@dashboard/leadDetail/LeadPinControl';
import { resolveActiveTreatment } from 'src/utils/activeTreatment';
import capitalizeFirstLetter from 'src/utils/capitalizedFunc';
import { isLeadId } from 'src/utils/leadId';

// store
import { useSelector, dispatch } from 'src/redux/store';
import { clearClinCheckData, getClinCheckList, setClincheckLoading } from 'src/redux/slices/clincheck';
import { markAsSpam as markLeadAsSpam } from 'src/redux/slices/spamLeads';
import {
    followUpSlice,
    getLeadNotes,
    getLeadReminderData,
    clearReminder,
    updateFollowUpLead,
    ArchivedLeadDashBoard,
    clearLead,
    clearLeadDetail,
    updateSteps,
    setAssigned,
    upComingTask,
    getLeadAllTreatmentPayments,
    addLeadTaskTab,
    leadTaskListCounter,
    updateLeadTaskCounter,
    tableLead,
    getAutoMatedMessages,
    AutoMatedMessageStatusUpdate,
    getAppointment,
    getTaskDetails,
    conversations,
    getLeadNotesWithFilter,
    setAction,
    setLoadingApis,
    setLeadDetailTaskPageFilter,
    setLeadDetailNotFound,
    updatePersonalDetail,
} from 'src/redux/slices/lead';
import { beginArchiveLead } from 'src/redux/slices/lead/coreThunks';
import { clearPracticeUserData } from 'src/redux/slices/practiceUser';
import { getActivities } from 'src/redux/slices/activity';
import { switchPractice } from 'src/redux/slices/practiceTreatmentList';
import { getPracticeTreatmentList } from 'src/redux/slices/practiceTreatment';
import { getAllTagItem, getTagItem } from 'src/redux/slices/tagsCreate';
import useDentallyIntegrationScope from 'src/hooks/useDentallyIntegrationScope';
import useDentallyPatientLink from 'src/hooks/useDentallyPatientLink';
import DentallyPatientLinkChip from 'src/components/dentally/DentallyPatientLinkChip';
import DentallyPossibleMatchBadge from 'src/components/dentally/DentallyPossibleMatchBadge';
import { getDentallyPossibleMatch } from 'src/utils/dentallyPossibleMatch';
import DentallyNextBookingChip from 'src/components/dentally/DentallyNextBookingChip';
import { DentallyLeadProvider } from 'src/contexts/DentallyLeadContext';
import { getNextTreatmentBooking } from 'src/utils/nextTreatmentBooking';
// Canonical /form-deliveries/ slice (Track A.3 migration). Same exported thunk
// name, new URL prefix, and the data lands in `state.formDeliveries` which
// Lead Detail's Forms tab and the Next-step engine now read from.
import { getLeadConsentRequests } from 'src/redux/slices/formDeliveries';
// hooks/routes
import {
    useTabs,
    useToggle,
    useReminderToggle,
    usePaymentToggle,
    useSwitchUserToggle,
    useConsentToggle,
    useArchivedToggle,
    useAssignTaskToggle,
    useAuth,
} from 'src/hooks';
// styles
import { primary, warning } from 'src/theme/palette';
import {
    iconBox,
    iconBtn,
    paperMenuList,
    paperMenuItem2,
    paperBox,
    poperStyle,
    tabLabelStyle,
    threeDotsBtn,
    paperMenuItem,
    editDetailMenuItem,
    archivingMenuItem,
    frostedHeaderCard,
    headerTopRow,
    leadNameStyle,
    lifecycleBarWrapper,
    lifecycleDot,
    lifecycleConnector,
    lifecycleLabel,
    commHubWrapper,
    commHubButton,
    metadataRow,
    pillBadge,
} from 'src/styles/LeadDetailView';
// constant
import { TASK_TAB_HEAD, CreateLeadHeaderData, JOURNEY_STAGES, getStageIndex, getMostAdvancedStatus } from 'src/constants/LeadDetailConst';
import { TASKS_V2_CHANGED_EVENT } from 'src/constants/tasksV2';
import { getAssignees } from 'src/utils/multiAsignees';
import { PHONE_BADGE_TEXT, phoneProblem } from 'src/utils/leadPhone';
import { piiProps } from 'src/components/DemoBlur';
import { useCanTransferLead } from 'src/hooks/useHasMultiplePractices';
import TransferLeadDialog from 'src/components/dialogPopUp/TransferLeadDialog';
import ArchivedLeadEmptyState from './ArchivedLeadEmptyState';
import LeadPageCallButton from '../../../components/outbound/LeadPageCallButton';

// ── Page-shell loading skeleton ──────────────────────────────────────────────
// Shown while `leadDetail` (Redux state.lead.leadDetail) is null — i.e. the
// initial slow API fetch hasn't resolved yet. Mirrors the real header card +
// tab strip + content-area layout so there is zero blank screen.
// Does NOT touch OverView.jsx, TaskChecklistCard, or the taskSummaryReady gate.
function LeadDetailLoadingSkeleton() {
    return (
        <Box data-testid="lead-detail-page-shell-skeleton">
            {/* Header card skeleton — matches frostedHeaderCard layout */}
            <Card
                sx={{
                    p: '24px 24px 0 24px',
                    width: '100%',
                    backdropFilter: 'blur(6px)',
                    bgcolor: 'rgba(255,255,255,0.8)',
                    borderRadius: '16px',
                    border: '1px solid rgba(145, 158, 171, 0.12)',
                }}
            >
                {/* Row 1: lead name + comm-hub icons */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Skeleton variant="text" width={220} height={36} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="circular" width={28} height={28} />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Skeleton variant="circular" width={36} height={36} />
                        <Skeleton variant="circular" width={36} height={36} />
                        <Skeleton variant="circular" width={36} height={36} />
                    </Box>
                </Box>

                {/* Row 2: created date + treatment chip */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                    <Skeleton variant="text" width={130} height={18} />
                    <Skeleton variant="rounded" width={80} height={20} sx={{ borderRadius: '10px' }} />
                </Box>

                {/* Row 3: lifecycle bar — 5 dots + connectors */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2.5, px: 2 }}>
                    {[0, 1, 2, 3, 4].map((i) => (
                        <Box key={i} sx={{ display: 'flex', alignItems: 'center', flex: i < 4 ? 1 : 'none' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                <Skeleton variant="circular" width={26} height={26} />
                                <Skeleton variant="text" width={54} height={13} />
                            </Box>
                            {i < 4 && (
                                <Skeleton
                                    variant="rectangular"
                                    sx={{ flex: 1, mx: 0.5, height: 2, borderRadius: 1 }}
                                />
                            )}
                        </Box>
                    ))}
                </Box>

                {/* Row 4: metadata pill badges */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
                    <Skeleton variant="rounded" width={140} height={26} sx={{ borderRadius: '13px' }} />
                    <Skeleton variant="rounded" width={100} height={26} sx={{ borderRadius: '13px' }} />
                    <Skeleton variant="rounded" width={90} height={26} sx={{ borderRadius: '13px' }} />
                </Box>

                {/* Tab strip */}
                <Box sx={{ display: 'flex', gap: 1.5, pb: 0, borderBottom: '1px solid rgba(145, 158, 171, 0.24)' }}>
                    {[80, 96, 60, 76, 72, 60, 120, 100].map((w, i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <Skeleton key={i} variant="text" width={w} height={42} sx={{ flexShrink: 0 }} />
                    ))}
                </Box>
            </Card>

            {/* Content area skeleton — mirrors Overview two-column layout */}
            <Grid container spacing={2} sx={{ mt: 0.5 }}>
                <Grid item xs={12} md={8}>
                    <Skeleton variant="rounded" height={180} sx={{ borderRadius: '12px', mb: 2 }} />
                    <Skeleton variant="rounded" height={120} sx={{ borderRadius: '12px' }} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Skeleton variant="rounded" height={160} sx={{ borderRadius: '12px' }} />
                </Grid>
            </Grid>
        </Box>
    );
}

function LeadDetailViewBodyInner({ leadId: id, practiceId: selectedId, embedded, onNotFound, locationState, locationSearch }) {
    const combineNotes = [];
    const navigate = useNavigate();
    const dashboardHomePath = useDashboardHomePath();
    const settings = useSettingsContext();
    const theme = useTheme();
    const isLight = theme.palette.mode === 'light';
    const isMobileDetail = useMediaQuery('(max-width:768px)');
    const [value] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElAssign, setAnchorElAssign] = useState(null);
    const [openPlusBtn, setOpenPlusBtn] = useState(false);
    const [NotesLength, setNotesLength] = useState([]);
    const [sentTasks, setSentTasks] = useState([]);
    const [cancelTask, setCancelTask] = useState([]);
    const [upcommingTask, setUpcommingTask] = useState([]);
    const [failedTasks, setFailedTasks] = useState([]);
    const [open, setOpen] = useState(false);
    const [templateOpen, setTemplateOpen] = useState('');
    const [treatmentId, setTreatmentId] = useState(null);
    const [validStep, setValidStep] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [loaderData, setLoaderData] = useState(null);
    const state = locationState ?? null;
    const [leadData, setLeadData] = useState({
        lead_id: '',
        treatment_id: '',
        price: '',
        first_name: '',
        last_name: '',
        status: '',
        treatment_name: '',
        created_at_human: '',
    });
    // Capture autoAction immediately before handleTabs wipes navigation state
    const autoActionRef = useRef(state?.autoAction || null);
    const [openContactFromCall, setOpenContactFromCall] = useState(false);
    const [spamConfirmOpen, setSpamConfirmOpen] = useState(false);
    const [backfillPreviewOpen, setBackfillPreviewOpen] = useState(false);
    const { user } = useAuth();
    const isSuperuser = !!user?.is_superuser;
    const [isEditingName, setIsEditingName] = useState(false);
    const [editNameValue, setEditNameValue] = useState('');
    const nameInputRef = useRef(null);
    const [options, setOptions] = useState('');
    const [selectTreatmentData, setSelectTreatmentData] = useState('');
    const selectedTab = locationSearch ? new URLSearchParams(locationSearch).get('tab') : null;
    const anchorRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const { activityList } = useSelector((state) => state.activity);
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const { isTasksCompleted, pageDetail, action } = useSelector((state) => state.lead);
    const { referral } = useSelector((state) => state.schema);
    const { currentTab, onChangeTab } = useTabs(selectedTab || 'Overview');
    const inputRef = useRef();
    const {
        leadDetail,
        leadDetailNotFound,
        leadNotes,
        leadReminder,
        followUpLead,
        markAsComplete,
        paymentComplete,
        leadNotesArr,
        autoMatedMessages,
        taskLeadCounter,
        taskCounter,
    } = useSelector((state) => state.lead);
    // Dentally: one practice/lead-scoped patient-link lookup shared by the hero chip and
    // Personal details. Gated on the route practice's active integration + view access.
    // NOTE: must stay below the `leadDetail` destructure above — reading it earlier is a TDZ
    // ReferenceError at render (white screen) that Jest's Babel build does not reproduce.
    const dentallyScope = useDentallyIntegrationScope(practiceId);
    const dentallyPatientLink = useDentallyPatientLink(
        dentallyScope.visible ? practiceId : null,
        dentallyScope.visible ? leadDetail?.id : null,
    );
    // Shared with descendants via context: the Personal details step element is captured once in
    // useState(STEPS), so props passed to it would freeze at their initial (loading) values.
    const dentallyLeadContextValue = React.useMemo(
        () => ({ scope: dentallyScope, patientLink: dentallyPatientLink }),
        [dentallyScope, dentallyPatientLink],
    );
    // Primary/most-recent treatment as a LOCAL default for this page's data-context
    // (call-script / ClinCheck / merge-tag prefetch + archive default). No global read.
    // TODO(active-treatment-removal): thread the treatment explicitly into those launchers.
    const activeTreatment = resolveActiveTreatment(leadDetail, null);
    // Wave 1: selected active treatment with safe fallback to the first treatment.
    const selectedTreatment = activeTreatment || leadDetail?.lead_treatments?.[0];
    // Next active booking for the SELECTED treatment only (never the first appointment on the lead).
    const nextTreatmentBooking = React.useMemo(
        () => (dentallyScope.visible ? getNextTreatmentBooking(selectedTreatment) : { next: null, others: 0 }),
        [dentallyScope.visible, selectedTreatment],
    );
    // Deep link: Treatments tab → this treatment → Appointments subtab → this appointment row.
    const openTreatmentAppointment = (treatmentId, appointmentId) => {
        const params = new URLSearchParams(window.location.search);
        params.set('tab', 'Treatments');
        if (treatmentId != null) params.set('treatmentId', String(treatmentId));
        params.set('treatmentTab', 'Appointments');
        if (appointmentId != null) params.set('appointmentId', String(appointmentId));
        onChangeTab('', 'Treatments');
        setSelectTreatmentData('');
        navigate(`?${params.toString()}`);
    };

    const { openCallScriptFromLeadPage } = useSelector((state) => state.callScript);
    // Track A.3 — read from canonical /form-deliveries/ slice. The legacy
    // `consentV2` selector still works but won't be populated by the new
    // `getLeadConsentRequests` thunk import above.
    const { leadConsentRequests } = useSelector((state) => state.formDeliveries);

    // Current lead's tags — shown inline as small chips next to the "Add tags"
    // trigger so the user sees what's there without opening the popover.
    const { getTag: leadTags = [] } = useSelector((state) => state.tagsCreate || {});

    // Tasks V2 badge count. The legacy `taskLeadCounter` reads from /reminders/
    // (V1 endpoint) and returns 0 for fully-migrated V2 leads, so the Tasks
    // tab showed `0` even when the lead had active V2 tasks/checklists.
    // For V2 practices, fetch the count from /tasks/?lead=&status__in=...
    // and use that for the badge. V1 practices keep the legacy counter.
    const { canView: hasTasksV2 } = useFeaturePermission('tasks-v2');
    const { canView: hasConsultationRecording } = useFeaturePermission('clinic-consultation-recording');
    const [tasksV2Count, setTasksV2Count] = useState(0);
    const [tasksV2RefetchKey, setTasksV2RefetchKey] = useState(0);

    // Polish C — form-state summary chip for the lead header.
    // Reuses the consent-requests payload already loaded by `getLeadConsentRequests`
    // (see line 392). No extra API call. Counts and a primary status are
    // derived purely client-side; if the lead has zero requests the chip
    // is hidden entirely.
    const formChipSummary = React.useMemo(() => {
        const list = leadConsentRequests?.results || [];
        if (!Array.isArray(list) || list.length === 0) return null;
        const counts = { PENDING: 0, OPENED: 0, SUBMITTED: 0, EXPIRED: 0, REVOKED: 0 };
        list.forEach((r) => {
            const s = r?.status || 'PENDING';
            if (counts[s] !== undefined) counts[s] += 1;
        });
        // Pick the most-recently-changed request as the primary signal.
        const sorted = [...list].sort((a, b) => {
            const ta = new Date(a?.submitted_at || a?.first_opened_at || a?.created_at || 0).getTime();
            const tb = new Date(b?.submitted_at || b?.first_opened_at || b?.created_at || 0).getTime();
            return tb - ta;
        });
        const primary = sorted[0]?.status || 'PENDING';
        const tooltipParts = [];
        if (counts.PENDING) tooltipParts.push(`${counts.PENDING} pending`);
        if (counts.OPENED) tooltipParts.push(`${counts.OPENED} opened`);
        if (counts.SUBMITTED) tooltipParts.push(`${counts.SUBMITTED} submitted`);
        if (counts.EXPIRED) tooltipParts.push(`${counts.EXPIRED} expired`);
        if (counts.REVOKED) tooltipParts.push(`${counts.REVOKED} revoked`);
        // Mirror status palette from FormRequestCard.STATUS_CONFIG.
        const palette = {
            PENDING:   { label: 'Form pending',   bg: 'rgba(255,171,0,0.12)',   fg: '#FFAB00' },
            OPENED:    { label: 'Form opened',    bg: 'rgba(7,141,238,0.12)',   fg: '#078DEE' },
            SUBMITTED: { label: 'Form submitted', bg: 'rgba(0,171,85,0.12)',    fg: '#00AB55' },
            EXPIRED:   { label: 'Form expired',   bg: 'rgba(145,158,171,0.12)', fg: '#919EAB' },
            REVOKED:   { label: 'Form revoked',   bg: 'rgba(183,33,54,0.12)',   fg: '#B72136' },
        };
        const cfg = palette[primary] || palette.PENDING;
        // Multiple states → use neutral aggregate label.
        const distinct = Object.values(counts).filter((n) => n > 0).length;
        const label = distinct > 1 ? `${list.length} forms` : cfg.label;
        return { label, tooltip: tooltipParts.join(', ') || cfg.label, bg: cfg.bg, fg: cfg.fg };
    }, [leadConsentRequests]);

    // ─── Patient-initiated "send me a fresh link" banner ──────────────────
    // The public already-submitted gate (ConsentFormAlreadySubmitted.jsx)
    // calls PublicFormsRequestResendView, which stamps
    // ``new_link_requested_at`` + ``new_link_request_count`` on the CR
    // (migration 0309). Here we surface every pending request so staff
    // can ack with a single click — clicking "Send new link" pre-loads
    // the SendFormsDialog with that lead so they can pick the form +
    // template and dispatch a fresh CR.
    //
    // Pending = ``new_link_requested_at`` is set AND there is no later
    // CR for the same form (a freshly-issued CR clears the signal
    // implicitly because the FE picks the most-recent CR per form). We
    // also de-duplicate by form_name so a patient who hammered the
    // button on multiple forms only gets one banner per form.
    const pendingResendRequests = React.useMemo(() => {
        const list = leadConsentRequests?.results || [];
        if (!Array.isArray(list) || list.length === 0) return [];

        // Sort newest-first so when we de-dup by form we keep the latest CR,
        // which is the one the resend signal should be read from. A newer
        // CR without a stamp means staff already followed up.
        const sorted = [...list].sort((a, b) => {
            const ta = new Date(a?.created_at || 0).getTime();
            const tb = new Date(b?.created_at || 0).getTime();
            return tb - ta;
        });

        const seen = new Set();
        const pending = [];
        sorted.forEach((cr) => {
            const formKey = cr?.form_name || cr?.form_id || cr?.id;
            if (seen.has(formKey)) return;
            seen.add(formKey);
            if (cr?.new_link_requested_at) pending.push(cr);
        });
        return pending;
    }, [leadConsentRequests]);

    const treatmentStatus = selectedTreatment?.status;
    const isInvisalignTreatment = () => selectedTreatment?.treatment === 'Invisalign';

    const loaderValue = [
        leadDetail,
        leadNotes,
        leadReminder,
        paymentComplete,
        leadNotesArr,
        autoMatedMessages,
        taskLeadCounter,
        activityList,
    ].every((v) => v !== null && v !== undefined);

    const STEPS = [
        {
            label: 'Personal details',
            component: <LeadDetailsPersonalDetails ref={inputRef} handleNext={(data) => setValidStep(!!data)} />,
        },
    ];
    const [leadStep, setLeadStep] = useState(STEPS);

    const cleanUp = () => {
        dispatch(clearReminder());
        dispatch(clearLeadDetail());
        dispatch(setAssigned(false));
        dispatch(upComingTask(null));
        dispatch(updateLeadTaskCounter([]));
        dispatch(setLeadDetailNotFound(false));
    };

    useEffect(() => {
        if (STEPS) {
            setLeadStep(STEPS);
        }
        if (action) {
            dispatch(setAction(null));
        }
        return () => cleanUp();
    }, []);

    // leadDetailNotFound is handled inline in the render return below — no side-effect needed.

    const editTreatmentDisable = () => {
        if (selectedTreatment?.status === 'CLOSED' || selectedTreatment?.status === undefined) {
            return false;
        }
        return true;
    };

    const { v1Enabled, v2Enabled } = useFormsFlags();

    const plusBtnPoper = [
        {
            value: 'Call script',
            icon: 'eva:menu-2-fill',
            subject: 'Open call script',
        },
        ...(hasConsultationRecording ? [{
            value: 'Record consultation',
            icon: 'solar:microphone-2-bold',
            subject: 'Record an in-clinic consultation',
        }] : []),
        {
            value: 'Create task',
            icon: 'fluent-mdl2:completed',
            subject: 'Set tasks and reminders for this lead',
            show: editTreatmentDisable() ? null : 'none',
        },
        {
            value: 'Add note',
            icon: 'ri:book-fill',
            subject: 'Create note for you and your team',
        },
        {
            value: 'Take a Payment',
            icon: 'majesticons:pound-circle',
            subject: 'Take a payment or deposit',
            show: editTreatmentDisable() ? null : 'none',
        },
        ...(v1Enabled ? [{
            value: 'Create  Consent',
            icon: 'fluent:form-new-24-filled',
            show: editTreatmentDisable() ? null : 'none',
        }] : []),
        ...(v2Enabled ? [{
            value: 'Generate Consent Link',
            icon: 'mdi:file-document-edit-outline',
            subject: 'Generate a consent form link',
            show: editTreatmentDisable() ? null : 'none',
        }] : []),
    ];

    const reloadTaskCounter = ({ userId, id, additionalFilter, CompletedTask }) => {
        if (practiceId) {
            dispatch(setLoadingApis([
                'All',
                'TODO',
                'NEW',
                'CONSULTATION_BOOKED',
                'CONSULTATION_ATTENDED',
                'TREATMENT_STARTED',
                'FAILED_TO_ATTEND_CONSULTATION',
                'CLOSED',
            ]));
            TASK_TAB_HEAD.forEach((data) => {
                dispatch(
                    leadTaskListCounter(
                        practiceId,
                        'LeadDetail',
                        data.value,
                        id,
                        userId && userId,
                        additionalFilter,
                        CompletedTask
                    )
                );
            });
            // Refresh the V2 badge count too — V1 practices ignore this since
            // the V2 fetch effect bails out when hasTasksV2 is false.
            setTasksV2RefetchKey((k) => k + 1);
        }
    };

    useEffect(() => {
        // A link that put the whole lead in the URL ('/lead-detail/[object Object]',
        // Sentry JAVASCRIPT-REACT-1G2) made both requests below fail with a 500.
        // The render below shows the broken-link message instead.
        if (id && isLeadId(id)) {
            dispatch(setLeadDetailTaskPageFilter('Today'));
            dispatch(followUpSlice(id, selectedId || practiceId, 'LeadDetail'));
            dispatch(conversations(id, selectedId || practiceId));
        }
    }, [id, selectedId]);

    // Reset the multi-treatment global on lead change so no downstream
    // getCurrentTreatmentIdV2(undefined) fallback uses a prior lead's treatment.
    useEffect(() => {
        dispatch(setCurrentTreatmentDataGlobal(null));
    }, [id]);

    useEffect(() => {
        if (selectedId) {
            dispatch(switchPractice(selectedId));
        }
    }, [selectedId]);

    useEffect(() => {
        if (leadDetail) {
            dispatch(getLeadNotes(id, practiceId, handleSuccess));
            dispatch(getLeadNotesWithFilter(id, practiceId, handleSuccess));
            dispatch(
                getLeadReminderData(
                    practiceId,
                    'LeadDetail',
                    10,
                    0,
                    'leadNotes',
                    id,
                    '',
                    '',
                    '',
                    'counter',
                    '',
                    isTasksCompleted
                )
            );
            // Need for future use
            // dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'firstTime', '', leadDetailTaskPageFilter));
            dispatch(getActivities(practiceId, id, 10, 0));
            dispatch(setAssigned(false));
            dispatch(addLeadTaskTab(''));
            reloadTaskCounter({ id, additionalFilter: 'Today', CompletedTask: isTasksCompleted });
            dispatch(getAutoMatedMessages(practiceId, id));
            dispatch(getAppointment(practiceId, id));
            dispatch(getLeadConsentRequests(practiceId, id));
            dispatch(getAllTagItem(practiceId, 30, 0));
            // Scope the tag slice to THIS lead so the inline chips show
            // the right tags. AutocompleteTags also dispatches this when
            // its Popover opens, but reading-before-opening (chips render
            // on header mount) requires we do it here too — otherwise the
            // chips would show whichever lead's tags happened to be the
            // last write to the shared `tagsCreate.getTag` slot.
            dispatch(getTagItem(practiceId, id));
            const data = {
                limit: 30,
                offset: 0,
            };
            dispatch(getPracticeTreatmentList(practiceId, data));
            dispatch(fetchMergeTagValueForLeads(id));
        }
    }, [leadDetail]);

    // Treatment-specific fetches — re-run when the SELECTED treatment changes,
    // without re-firing the lead-level fetches above. Guarded so a stale leadDetail
    // (previous lead during navigation) can't request leads/{newId}/treatments/{oldId}/ → 404.
    useEffect(() => {
        if (!leadDetail || String(leadDetail?.id) !== String(id)) return;
        const treatmentName = selectedTreatment?.treatment || '';
        if (practiceId) {
            dispatch(getCallScriptSection({ practiceId, treatment: treatmentName, isTemplate: false, category: 'OUTBOUND' }));
        }
        if (selectedTreatment?.id) {
            const clinCheckData = { leadId: id, treatmentId: selectedTreatment?.id, practiceId };
            dispatch(clearClinCheckData());
            dispatch(getClinCheckList(clinCheckData));
            dispatch(fetchMergeTagValueForTreatments(id, selectedTreatment?.id));
        } else {
            dispatch(fetchMergeTagValueForTreatments());
        }
    }, [selectedTreatment?.id, leadDetail?.id, practiceId]);

    useEffect(() => {
        if (
            practiceId &&
            leadDetail &&
            String(leadDetail?.id) === String(id) &&
            treatmentId &&
            leadDetail.lead_treatments?.some((t) => String(t.id) === String(treatmentId))
        ) {
            dispatch(getLeadAllTreatmentPayments(practiceId, leadDetail?.id, leadDetail?.lead_treatments));
        }
    }, [treatmentId, leadDetail?.id]);

    // Listen for V2 checklist-item completions fired from ChecklistItemRow.
    // Bumps the V2 refetch key so the Tasks badge refreshes without waiting for
    // a full task-level reload. Also re-fetches leadDetail so lead_contacted_counts
    // (the single source of truth for the "Contact attempts" pill) reflects the
    // BE bump that fires on checklist contact-item completion.
    useEffect(() => {
        if (!hasTasksV2) return;
        const handler = (e) => {
            // Always refresh the Tasks-tab badge count (cheap).
            setTasksV2RefetchKey((k) => k + 1);
            // Refresh the lead Timeline activities (+ the "Timeline N" badge count).
            // Completing/reopening/renaming a task logs a timeline Action, so the
            // Timeline badge must move too — cheap, runs for every task change.
            dispatch(getActivities(practiceId, id, 10, 0));
            // Only do the FULL lead refetch for un-sourced events — i.e. raw
            // per-item checklist completions (ChecklistItemRow) that can change
            // lead_contacted_counts (the "Contact attempts" pill). Tab-level
            // actions (complete/reopen/add/bulk) carry a `source` and must NOT
            // trigger a full reload — that caused the whole-page flicker.
            if (!e?.detail?.source) {
                dispatch(followUpSlice(id, practiceId, 'LeadDetail'));
            }
        };
        window.addEventListener('lead-tasks-v2-changed', handler);
        // Also listen on the secondary bus (taskSlice / TaskChecklistField /
        // AttendedGuidedChecklistV2) so cross-bus mutations refresh the Tasks
        // badge and Timeline without waiting for a popup close. The same handler
        // is reused; TASKS_V2_CHANGED_EVENT carries no `detail.source` (plain
        // Event, not CustomEvent) so `!e?.detail?.source` is truthy → full lead
        // refetch fires, which is correct for table-cell completions.
        window.addEventListener(TASKS_V2_CHANGED_EVENT, handler);
        // eslint-disable-next-line consistent-return
        return () => {
            window.removeEventListener('lead-tasks-v2-changed', handler);
            window.removeEventListener(TASKS_V2_CHANGED_EVENT, handler);
        };
    }, [hasTasksV2, id, practiceId]);

    // Fetches the V2 Tasks badge count for the lead-detail header.
    // /tasks/?status__in=pending,in_progress&limit=1 → `data.count` is the
    // Tasks-tab badge value (matches what `LeadTaskList` shows as active rows).
    //
    // The "Contact attempts" pill now reads lead_contacted_counts from leadDetail
    // directly (single source of truth, same as the action-button + sub-tabs).
    // leadDetail is refreshed by the lead-tasks-v2-changed handler above whenever
    // a checklist item is completed.
    useEffect(() => {
        if (!hasTasksV2 || !practiceId || !leadDetail?.id) return;
        let cancelled = false;
        (async () => {
            const badgeRes = await callApi(`/api/v1/practices/${practiceId}/tasks/?lead=${leadDetail.id}&status__in=pending,in_progress&limit=1`);
            if (cancelled) return;
            if (badgeRes?.status === 200) {
                setTasksV2Count(badgeRes.data?.count || 0);
            }
        })();
        // eslint-disable-next-line consistent-return
        return () => { cancelled = true; };
    }, [hasTasksV2, practiceId, leadDetail?.id, tasksV2RefetchKey]);

    useEffect(() => {
        if (leadDetail && leadDetail?.lead_contact?.note !== '') {
            combineNotes.push(leadDetail);
        }
        if (leadNotesArr && leadNotesArr?.results?.length > 0) {
            combineNotes.push(...leadNotesArr.results.filter((el) => el.note !== ''));
        }
        if (leadNotes && leadNotes.length > 0) {
            combineNotes.push(...leadNotes.filter((el) => el.additional_notes !== ''));
        }
        if (combineNotes) {
            setNotesLength(
                combineNotes.sort(
                    (a, b) =>
                        new Date(moment(a.updated_at, 'DD-MM-YYYY HH:mm:ss')) -
                        new Date(moment(b.updated_at, 'DD-MM-YYYY HH:mm:ss'))
                )
            );
        }
        if (leadDetail?.lead_treatments.length > 0) {
            setTreatmentId(selectedTreatment?.id);
        }
    }, [leadReminder, leadNotes, leadDetail, leadNotesArr, activeTreatment?.id]);

    useEffect(() => {
        // 'Take a Payment' is now sent explicitly from OpenPayment's Finish button
        // (see OpenPayment.jsx processPayment) instead of this markAsComplete+
        // followUpLead race — that race is what let PaymentOption's undefined
        // handleNext(true) crash (Sentry JAVASCRIPT-REACT-D9) while the payment
        // still silently fired via this listener. Do not reintroduce this branch —
        // it would double-send alongside the explicit call.
        if (markAsComplete && followUpLead === 'archivedLead') {
            dispatch(ArchivedLeadDashBoard(handleClose));
        }
    }, [followUpLead, markAsComplete]);

    const onUpdateStatus = (value, taskId) => {
        const detail = {
            is_cancelled: value,
        };
        dispatch(AutoMatedMessageStatusUpdate(practiceId, id, taskId, detail, handleSuccess));
    };

    const handleLoading = (data) => {
        if (data === 'start') {
            setLoaderData(true);
            return;
        }
        setLoaderData(false);
    };
    useEffect(() => {
        if (!openCallScriptFromLeadPage && selectedTab) {
            onChangeTab('', selectedTab)
        }
    }, [openCallScriptFromLeadPage])

    useEffect(() => {
        if (!openContactFromCall && selectedTab) {
            onChangeTab('', selectedTab)
        }
    }, [openContactFromCall])


    const handleMenuItems = (value) => {
        if (value === 'Create task') {
            dispatch(updateFollowUpLead(value));
            onOpenReminder();
        }
        if (value === 'Take a Payment') {
            dispatch(updateFollowUpLead(value));
            onOpenPayment();
        }
        if (value === 'Add note') {
            onOpenSwitchUser();
        }
        if (value === 'Create  Consent') {
            onOpenConsent();
        }
        if (value === 'Generate Consent Link') {
            setConsentV2Open(true);
        }
        if (value === 'Call script') {
            onChangeTab('', 'Overview');
            setOpenContactFromCall(true);
            dispatch(setOpenCallScriptFromLeadPage(true));
            setOpenPlusBtn(false);
        }
        if (value === 'Record consultation') {
            handleTabs('', 'Consultations');
            setOpenPlusBtn(false);
        }
    };

    const { toggle: leadDetailModal, onClose: onCloseLeadDetail } = useToggle();

    const closeEditDetails = () => {
        onCloseLeadDetail();
    };

    const ACCOUNT_TABS = [
        {
            value: 'Overview',
            component: (
                <OverView
                    leadDetail={leadDetail}
                    activityList={activityList.results}
                    onChangeTab={onChangeTab}
                    practiceId={practiceId}
                    reloadTaskCounter={reloadTaskCounter}
                    handleLoading={handleLoading}
                    LeadNotes={NotesLength}
                    handleMenuItems={handleMenuItems}
                    setSelectTreatmentData={setSelectTreatmentData}
                    setOpenContactFromCall={setOpenContactFromCall}
                    openContactFromCall={openContactFromCall}
                    autoAction={autoActionRef.current}
                />
            ),
        },
        ...(hasConsultationRecording ? [{
            value: 'Consultations',
            component: <ConsultationRecordings leadDetail={leadDetail} />,
        }] : []),
        {
            value: 'All communications',
            component: <Communication leadDetail={leadDetail} autoMatedMessages={autoMatedMessages} sentTasks={sentTasks} upcommingTask={upcommingTask} cancelTask={cancelTask} failedTasks={failedTasks} onUpdateStatus={onUpdateStatus} handleLeadDetailClose={(data) => setValidStep(!!data)} />,
        },
        {
            value: 'Tasks',
            component: (
                <LeadDetailTasks
                    reminder={leadReminder}
                    leadDetail={leadDetail}
                    reloadTaskCounter={reloadTaskCounter}
                    handleLoading={handleLoading}
                />
            ),
        },
        {
            value: 'Treatments',
            component: (
                <TreatmentsDetails
                    leadDetail={leadDetail}
                    reminder={leadReminder}
                    reloadTaskCounter={reloadTaskCounter}
                    counter={taskCounter}
                    handleLoading={handleLoading}
                    selectTreatmentData={selectTreatmentData}
                    setSelectTreatmentData={setSelectTreatmentData}
                />
            ),
        },
        {
            value: 'Forms',
            component: <LeadFormsTab leadDetail={leadDetail} />,
        },
        {
            value: 'Timeline',
            component: <Activities type={'leadDetail'} allow leadId={id} />,
        },
        {
            value: 'Notes',
            component: <AccountSocialLinks LeadNotes={NotesLength} leadDetail={leadDetail} />,
        },
        {
            value: 'Payment and refunds',
            // Internal `value` stays 'Payment and refunds' (used in URLs/deep
            // links like ?tab=Payment+and+refunds and in tab logic above) —
            // only the displayed label changes to "Payments".
            displayValue: 'Payments',
            component: <PaymentRefunds leadDetail={leadDetail} handleMenuItems={handleMenuItems} />,
        },
        {
            value: 'Source and meta data',
            component: <MetaSource leadDetail={leadDetail} />,
        },
        // Legacy 'Consent' tab removed — superseded by the new Forms tab which
        // groups consent / medical history / surveys under sub-tabs and reads
        // from the canonical /form-deliveries/ endpoint.
        {
            value: 'Personal details',
            component: <EditDialogPopup
                open
                onClose={closeEditDetails}
                steps={leadStep}
                type={'editLead'}
                validStep={validStep}
                updateStep={(type) => setValidStep(type)}
                inputRef={inputRef}
                title='Edit Details'
                headerButtons
            />,
        },
    ];

    const shouldRenderClinCheck = () =>
        (treatmentStatus === 'CONSULTATION_ATTENDED' || treatmentStatus === 'CONSULTATION_BOOKED') &&
        isInvisalignTreatment();

    const reloadClinCheck = () => {
        if (selectedTreatment?.id) {
            const clinCheckData = {
                leadId: id,
                treatmentId: selectedTreatment?.id,
                practiceId,
            };
            setTimeout(() => {
                dispatch(setClincheckLoading(true));
                dispatch(getClinCheckList(clinCheckData));
            }, 500);
        }
    };

    const TABS = shouldRenderClinCheck()
        ? [
            ...ACCOUNT_TABS,
            {
                value: 'ClinCheck Status',
                component: <LeadDetailClinCheck leadDetail={leadDetail} reloadClinCheck={reloadClinCheck} />,
            },
        ]
        : ACCOUNT_TABS;

    useEffect(() => {
        if (autoMatedMessages.results) {
            setSentTasks(autoMatedMessages?.results.filter((el) => el?.is_enqueued));
            setUpcommingTask(autoMatedMessages?.results.filter((el) => !el?.is_enqueued && !el?.is_cancelled));
            setCancelTask(autoMatedMessages?.results.filter((el) => !el?.is_enqueued && el?.is_cancelled));
            setFailedTasks(autoMatedMessages?.results.filter((el) => el.task_status === 'FAILED'));
        }
    }, [autoMatedMessages]);

    const handleClose = (status, archive) => {
        if (status?.toLowerCase?.() === 'finish' && archive) {
            onCloseArchiveLead();
            navigate(dashboardHomePath);
            dispatch(clearLead());
            dispatch(setCurrentTreatmentDataGlobal(null));
            return;
        }
        dispatch(clearLead());
        dispatch(setCurrentTreatmentDataGlobal(null));
        dispatch(updateSteps(null));
        dispatch(updateFollowUpLead(null));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 1, 0, '', leadDetail?.id, '', '', 'Graterthan'));
        dispatch(getLeadReminderData(practiceId, 'LeadDetail', 10, 0, '', id, ''));
    };

    const handleClosePayment = () => {
        onClosePayment();
        dispatch(getActivities(practiceId, id, 10, 0));
        dispatch(getLeadAllTreatmentPayments(practiceId, leadDetail?.id, leadDetail?.lead_treatments));
    };

    const { toggle: Payment, onOpen: onOpenPayment, onClose: onClosePayment } = usePaymentToggle();

    const { toggle: openReminder, onOpen: onOpenReminder, onClose: onCloseReminder } = useReminderToggle();

    const { toggle: openAssignTask, onOpen: onOpenSwitchUser, onClose: onCloseSwitchUser } = useSwitchUserToggle();

    const { toggle: openNotePopup, onClose: onCloseNotePopup } = useSwitchUserToggle();

    const { toggle: ConsentBuilder, onOpen: onOpenConsent, onClose: onCloseConsent } = useConsentToggle();
    const [consentV2Open, setConsentV2Open] = useState(false);

    const handleSuccess = (data) => {
        enqueueSnackbar(data.message || '', {
            variant: data.success ? 'success' : 'error',
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
        });
    };

    const tabCounter = (value) => {
        if (value === 'Notes') {
            return (NotesLength && NotesLength?.length) || 0;
        }
        if (value === 'Tasks') {
            // V2 practices: badge mirrors the active-task count from /tasks/.
            // V1 practices: keep the legacy /reminders/-based counter.
            if (hasTasksV2) return tasksV2Count;
            return taskLeadCounter?.filter((value) => (value.filter === '' ? value.count : 0))[0]?.count || 0;
        }
        if (value === 'Timeline') {
            return (activityList && activityList?.count) || 0;
        }
        if (value === 'Treatments') {
            return (leadDetail && leadDetail.lead_treatments && leadDetail.lead_treatments?.length) || 0;
        }
        if (value === 'Payment and refunds') {
            return (paymentComplete && paymentComplete?.length) || 0;
        }
        if (value === 'message_log') {
            return (autoMatedMessages && autoMatedMessages?.count) || 0;
        }
        if (value === 'Call Script') {
            // Prefer the slim-payload top-level count; fall back to the array length so the
            // counter still works if/when the slim list is paginated in future.
            return leadDetail?.form_submissions_count ?? leadDetail?.form_submissions?.length ?? 0;
        }
        // Forms tab badge — sourced from /form-deliveries/ count since every send creates a ConsentRequest. Mirrors the Forms tab's own internal "All N" chip.
        if (value === 'Forms') {
            return leadConsentRequests?.count || 0;
        }
        return 0;
    };

    const handleChoose = (e) => {
        setAnchorEl(e.currentTarget);
        setOpenPlusBtn(true);
    };

    const buttonHandleClose = (event) => {
        if (anchorEl.current && anchorEl.current.contains(event.target)) {
            return;
        }
        setOpenPlusBtn(false);
    };

    const getMobileLabel = (tabValue) => {
        const shortLabels = {
            'Overview': 'Overview',
            'Consultations': 'Consult',
            'All communications': 'Comms',
            'Tasks': 'Tasks',
            'Treatments': 'Treats',
            'Forms': 'Forms',
            'Timeline': 'Timeline',
            'Notes': 'Notes',
            'Payment and refunds': 'Payments',
            'Source and meta data': 'Source',
            'Personal details': 'Personal',
            'ClinCheck Status': 'ClinCheck',
        };
        return shortLabels[tabValue] || tabValue;
    };

    const labelCount = (data) => {
        const displayText = data.displayValue || data.value;
        // Legacy 'Consent' tab removed — its count badge logic is gone too.
        // Forms tab uses its own internal sub-tab counts so doesn't need a
        // top-level chip.
        if (data.value === 'ClinCheck Status' || data.value === 'Personal details') {
            return (
                <>
                    <Box sx={{ fontWeight: '600' }}>{displayText}</Box>
                </>
            );
        }
        if (data.value !== 'Overview' && data.value !== 'Consultations' && data.value !== 'Payment and refunds' && data.value !== 'Source and meta data' && data.value !== 'All communications') {
            return (
                <>
                    <Box sx={{ fontWeight: '600' }}>
                        {displayText}
                        <Label
                            color={currentTab === data.value ? 'primary' : 'default'}
                            sx={tabLabelStyle(isLight)}
                        >
                            {' '}
                            {tabCounter(data.value)}{' '}
                        </Label>
                    </Box>
                </>
            );
        }
        if (data.value === 'Source and meta data') {
            return (
                <>
                    <Box sx={{ textTransform: 'none !important' }}>{displayText}</Box>
                </>
            );
        }
        if (data.value === 'Payment and refunds') {
            return (
                <>
                    <Box sx={{ textTransform: 'none !important' }}>
                        {displayText}
                        <Label color={currentTab === data.value ? 'primary' : 'default'} sx={tabLabelStyle(isLight)}>
                            {' '}
                            {tabCounter(data.value)}{' '}
                        </Label>
                    </Box>
                </>
            );
        }
        return displayText;
    };

    useEffect(() => {
        if (leadData) {
            dispatch(tableLead(leadData));
        }
    }, [leadData]);

    const { toggle: openArchiveLead, onOpen: onOpenArchiveLead, onClose: onCloseArchiveLead } = useArchivedToggle();

    // "Transfer to another practice": only offered to users with more than one practice,
    // and never for a lead that is already archived / being archived.
    const canTransferLead = useCanTransferLead(leadDetail);
    const [transferOpen, setTransferOpen] = useState(false);

    // The original lead is archived by the transfer, so on success leave the detail
    // page exactly as the Archive action does. On failure stay put (the thunk has already
    // raised the error) so the user can see what state the lead is in.
    const handleTransferDone = (status, result) => {
        setTransferOpen(false);
        if (result?.archived) handleClose(status, true);
    };

    const archiveHandler = () => {
        setLeadData({
            lead_id: leadDetail?.id || '',
            treatment_id: activeTreatment?.id || '',
            price: activeTreatment?.price || '',
            first_name: leadDetail.first_name || '',
            last_name: leadDetail.last_name || '',
            status: activeTreatment?.status || '',
            treatment_name: activeTreatment?.treatment || '',
            lead_treatments__lead_contacted_counts__count:
                activeTreatment?.lead_contacted_counts?.find(
                    (item) => item.status === activeTreatment?.status
                )?.count || 0,
        });
        dispatch(updateFollowUpLead('archivedLead'));
        onOpenArchiveLead(leadDetail?.id);
    };

    const handleExplicitArchiveSubmit = async ({ data, openCommunication }) => {
        const archiveLeadId = leadData?.lead_id || leadDetail?.id;
        const archiveTreatmentId = leadData?.treatment_id || activeTreatment?.id || null;
        if (!archiveLeadId || !practiceId) {
            enqueueSnackbar('Cannot archive: lead not identified. Please close and reopen.', { variant: 'error' });
            return null;
        }

        await dispatch(beginArchiveLead({
            leadId: archiveLeadId,
            practiceId,
            leadTreatmentId: archiveTreatmentId,
            reason: data?.archiveReason || '',
            note: data?.archiveNotes || '',
            isOpenForCommunication: openCommunication?.is_open_for_communication,
            source: 'lead-detail:header',
            handleClose,
        }));
        return null;
    };

    const handleMarkAsSpamConfirm = () => {
        setSpamConfirmOpen(false);
        setOpen(false);
        dispatch(markLeadAsSpam({
            practiceId,
            leadId: leadDetail?.id,
            handleClose: (status) => {
                if (status === 'finish') {
                    navigate(dashboardHomePath);
                }
            },
        }));
    };

    const { toggle: openAssignToTask, onOpen: onOpenAssignTask, onClose: onCloseAssignTask } = useAssignTaskToggle();

    // Tag picker: pillBadge button is the trigger, AutocompleteTags renders
    // inside the popover at its natural width. Mirrors the Unassigned pattern.
    // The popoverContentRef is used to auto-open the autocomplete dropdown
    // once the popover transition completes (MUI Autocomplete needs an actual
    // click on its input to open — just being rendered/focused isn't enough).
    const [tagPopoverAnchor, setTagPopoverAnchor] = useState(null);
    const tagPopoverContentRef = useRef(null);

    const OpenAssignTask = (row, event) => {
        setAnchorElAssign(anchorElAssign ? null : event.currentTarget);
        onOpenAssignTask();
        setSelectedRowId(row?.id);
    };

    const onCloseAssignTaskPopup = () => {
        handleClose();
        onCloseAssignTask();
    };

    const editDetailEvent = () => {
        handleTabs('', 'Personal details');
        setOpen(false);
    };

    useEffect(() => {
        if (isEditingName && nameInputRef.current) {
            nameInputRef.current.focus();
        }
    }, [isEditingName]);

    const handleNameSave = () => {
        const trimmed = editNameValue.trim();
        if (!trimmed) {
            setIsEditingName(false);
            return;
        }
        const parts = trimmed.split(/\s+/);
        const firstName = parts[0];
        const lastName = parts.slice(1).join(' ');
        if (firstName === leadDetail?.first_name && lastName === (leadDetail?.last_name || '')) {
            setIsEditingName(false);
            return;
        }
        dispatch(updatePersonalDetail(
            { id: leadDetail.id, first_name: firstName, last_name: lastName },
            practiceId,
            () => setIsEditingName(false),
            'leadDetail'
        ));
    };

    useEffect(() => {
        if (state?.goToTaskTab) {
            handleTabs('', 'Tasks', state?.taskId);
        }
        if (state?.goToAllCommunicationTab) {
            handleTabs('', 'All communications', '', state?.leadId);
        }
        if (state?.goToWhatsappTab) {
            handleTabs('', 'All communications', '', '', state?.treatmentId);
        }
        if (state?.goToConsultationsTab && hasConsultationRecording) {
            handleTabs('', 'Consultations');
        }
        if (state?.shouldRedirectToOverview) {
            handleTabs('', 'Overview');
        }
    }, [state?.goToTaskTab, state?.goToAllCommunicationTab, state?.goToWhatsappTab, state?.goToConsultationsTab, state?.shouldRedirectToOverview]);

    const handleTabs = (e, value, taskId, leadId, treatmentId, isGoToWp, isGoToEmail, isGoToConsultations) => {
        onChangeTab(e, value);
        // Preserve existing query params (e.g. ?treatmentId= written by
        // ActiveTreatmentProvider) when switching tabs — otherwise the active
        // treatment is dropped from the URL on every tab change and the context
        // has to re-heal it, causing a render/replace race.
        const tabUrl = (() => {
            const params = new URLSearchParams(window.location.search);
            params.set('tab', value);
            return `?${params.toString()}`;
        })();
        if (taskId) {
            navigate(tabUrl, { state: { openSideBar: true, taskId } });
        } else if (leadId) {
            navigate(tabUrl, { state: { shouldCallCommunicationApi: true, leadId } });
        } else if (treatmentId) {
            navigate(tabUrl, { state: { goToWhatsappTab: Date.now(), treatmentId } });
        } else if (isGoToWp) {
            navigate(tabUrl, { state: { goToWhatsappTab: Date.now() } });
        } else if (isGoToEmail) {
            navigate(tabUrl, { state: { goToEmailTab: Date.now() } });
        } else if (isGoToConsultations) {
            navigate(tabUrl, { state: { goToConsultationsTab: Date.now() } });
        } else {
            navigate(tabUrl);
        }
        dispatch(getTaskDetails({}));
        if (value !== 'Treatments') {
            setSelectTreatmentData('');
        };
    };

    const handleCloseNotes = () => {
        onCloseSwitchUser();
        dispatch(getActivities(practiceId, id, 10, 0));
    };

    const handleCloseNotePopup = () => {
        onCloseNotePopup();
        dispatch(getActivities(practiceId, id, 10, 0));
        dispatch(followUpSlice(id, selectedId || practiceId, 'LeadDetail'));
    };

    const assigneeData = leadDetail?.assignees?.filter((el) => el?.user?.first_name && !el?.user?.is_superuser);

    const closeEmailCompose = () => {
        setTemplateOpen(false);
        setTimeout(() => {
            document.body.style.overflowY = 'auto';
        }, 500);
    };

    const onClickAwayEvent = () => {
        const selectMenu = document.querySelector('.MuiModal-root');
        if (selectMenu) {
            return;
        }
        onCloseAssignTaskPopup();
        setAnchorElAssign(null);
        dispatch(clearPracticeUserData());
    };

    // ── Archived / not-found empty state ─────────────────────────────────────
    // Shown when the lead 404s — almost always because it was just archived.
    // We render a friendly inline message rather than auto-closing so the user
    // can see what happened and navigate to the archive table if desired.
    // Nothing loads for a non-numeric id (see the fetch effect above), so say so
    // rather than leave the loading skeleton up forever.
    if (id && !isLeadId(id)) {
        return (
            <Box data-testid="lead-broken-link" sx={{ p: 6, display: 'flex', justifyContent: 'center' }}>
                <Alert
                    severity="error"
                    action={onNotFound ? <Button color="inherit" size="small" onClick={onNotFound}>Close</Button> : null}
                >
                    <AlertTitle>This lead link is broken</AlertTitle>
                    Open the lead from a table or search.
                </Alert>
            </Box>
        );
    }

    if (leadDetailNotFound) {
        return (
            <ArchivedLeadEmptyState
                leadId={id}
                practiceId={selectedId || practiceId}
                embedded={embedded}
                onClose={onNotFound}
            />
        );
    }

    return (
        <DentallyLeadProvider value={dentallyLeadContextValue}>
            {!embedded && (
                <Helmet>
                    <title> Lead Detail | Dental SEM CRM </title>
                </Helmet>
            )}
            <Container maxWidth={settings.themeStretch ? false : 'lg'}>
                {!embedded && (
                    <HeaderBreadcrumbs
                        heading='Lead details'
                        links={[
                            // Origin crumb(s): "<menu group> › <menu label>" when pageDetail's
                            // path matches a known table menu item, a single fallback crumb
                            // (e.g. WhatsApp's 'All Leads') when it doesn't, or nothing at all
                            // for a deep-link with no stored origin. No "Dashboard" crumb.
                            ...menuCrumbsForOrigin(pageDetail),
                            { name: 'Lead details' },
                            { name: `${leadDetail?.first_name || ''} ${leadDetail?.last_name || ''}`, pii: true },
                        ]}
                    />
                )}
                {/* Active-treatment selector removed — the treatment you act on is
                    now chosen by clicking its lane in the Overview (TreatmentLane). */}
                {/* Patient-initiated resend-request banner —
                    shown above the main detail card so staff
                    see it the moment the page loads. One Alert
                    per form (de-duplicated by ``form_name``).
                    Clicking "Send new link" opens the same
                    SendFormsDialog the header CTA uses, so the
                    resend follows the practice's normal
                    delivery template + audience-mode flow. */}
                {pendingResendRequests.length > 0 && (
                    <Stack spacing={1.5} sx={{ mt: 2 }}>
                        {pendingResendRequests.map((cr) => {
                            const requestedAt = cr?.new_link_requested_at;
                            const requestedAtMoment = requestedAt ? moment(requestedAt) : null;
                            const requestedAtLabel = requestedAtMoment && requestedAtMoment.isValid()
                                ? requestedAtMoment.fromNow()
                                : 'just now';
                            const formLabel = cr?.form_name || 'a form';
                            const requestCount = Number.isFinite(cr?.new_link_request_count)
                                ? cr.new_link_request_count
                                : 1;
                            return (
                                <Alert
                                    key={`resend-${cr.id}`}
                                    severity="warning"
                                    icon={<Iconify icon="solar:bell-bing-bold" />}
                                    action={
                                        <Button
                                            size="small"
                                            color="warning"
                                            variant="contained"
                                            onClick={() => setConsentV2Open(true)}
                                            sx={{ whiteSpace: 'nowrap' }}
                                        >
                                            Send new link
                                        </Button>
                                    }
                                    sx={{
                                        alignItems: 'center',
                                        '& .MuiAlert-action': { pt: 0, alignItems: 'center' },
                                    }}
                                >
                                    <AlertTitle sx={{ mb: 0.25 }}>
                                        Patient requested a new link for {formLabel}
                                    </AlertTitle>
                                    Requested {requestedAtLabel}
                                    {requestCount > 1 ? ` · ${requestCount} requests` : ''}
                                    {cr?.submitted_at ? ' · previous submission still on file' : ''}
                                </Alert>
                            );
                        })}
                    </Stack>
                )}
                {/* Page-shell skeleton — shown while leadDetail is loading.
                    Renders BEFORE OverView mounts (leadDetail gate below stays untouched).
                    Suppressed once leadDetail resolves or the not-found state fires. */}
                {!leadDetail && !leadDetailNotFound && (
                    <LeadDetailLoadingSkeleton />
                )}
                {leadDetail && (
                    <>
                        <Grid container sx={{ position: 'relative' }}>
                            <Card sx={frostedHeaderCard}>
                                {/* Row 1: Name + Three-dots + Communication Hub */}
                                <Box sx={headerTopRow}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                                        {isEditingName ? (
                                            <input
                                                ref={nameInputRef}
                                                value={editNameValue}
                                                onChange={(e) => setEditNameValue(e.target.value)}
                                                onBlur={handleNameSave}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { e.target.blur(); }
                                                    if (e.key === 'Escape') { setIsEditingName(false); }
                                                }}
                                                {...piiProps}
                                                style={{
                                                    fontWeight: 900,
                                                    fontSize: '24px',
                                                    lineHeight: '32px',
                                                    textTransform: 'capitalize',
                                                    border: 'none',
                                                    borderBottom: '2px solid #00AB55',
                                                    outline: 'none',
                                                    background: 'transparent',
                                                    padding: 0,
                                                    fontFamily: 'inherit',
                                                    width: '100%',
                                                    maxWidth: '400px',
                                                }}
                                            />
                                        ) : (
                                            <Typography
                                                {...piiProps}
                                                sx={{
                                                    ...leadNameStyle,
                                                    cursor: 'pointer',
                                                    '&:hover': { opacity: 0.7 },
                                                }}
                                                onClick={() => {
                                                    setEditNameValue(
                                                        `${leadDetail?.first_name || ''} ${leadDetail?.last_name || ''}`.trim()
                                                    );
                                                    setIsEditingName(true);
                                                }}
                                            >
                                                {leadDetail?.first_name} {leadDetail?.last_name}
                                            </Typography>
                                        )}
                                        <Box>
                                            <Button
                                                ref={anchorRef}
                                                id='composition-button'
                                                aria-controls={open ? 'composition-menu' : undefined}
                                                aria-expanded={open ? 'true' : undefined}
                                                aria-haspopup='true'
                                                onClick={() => setOpen((prevOpen) => !prevOpen)}
                                                sx={threeDotsBtn}
                                            >
                                                <Iconify sx={{ color: 'common.grey' }} icon={'bx:dots-vertical-rounded'} width={22} height={22} />
                                            </Button>
                                            <Popper
                                                sx={{
                                                    // Rendered in a portal (no disablePortal): the header card has
                                                    // overflow:hidden and clipped the lower menu items otherwise.
                                                    zIndex: (theme) => theme.zIndex.modal,
                                                    marginLeft: '10px !important',
                                                }}
                                                open={open}
                                                anchorEl={anchorRef.current}
                                                role={undefined}
                                                placement='bottom-start'
                                                transition
                                            >
                                                {({ TransitionProps, placement }) => (
                                                    <Grow
                                                        {...TransitionProps}
                                                        style={{
                                                            transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                                                            width: '180px',
                                                        }}
                                                    >
                                                        <Paper>
                                                            <ClickAwayListener onClickAway={() => setOpen((prevOpen) => !prevOpen)}>
                                                                <MenuList
                                                                    autoFocusItem={open}
                                                                    id='composition-menu'
                                                                    aria-labelledby='composition-button'
                                                                    sx={paperMenuItem}
                                                                >
                                                                    <MenuItem onClick={() => editDetailEvent()} sx={editDetailMenuItem}>
                                                                        <Iconify icon={'solar:pen-bold'} sx={{ mr: 1 }} />
                                                                        Edit Detail
                                                                    </MenuItem>
                                                                    <Divider sx={{ borderStyle: 'dashed' }} />
                                                                    {canTransferLead && (
                                                                        <MenuItem
                                                                            data-testid="lead-detail-transfer-menu-item"
                                                                            onClick={() => { setOpen(false); setTransferOpen(true); }}
                                                                            sx={{ ...editDetailMenuItem, whiteSpace: 'normal', lineHeight: 1.3, py: 0.75 }}
                                                                        >
                                                                            <Iconify icon={'eva:swap-fill'} sx={{ mr: 1, flexShrink: 0 }} />
                                                                            Transfer to another practice
                                                                        </MenuItem>
                                                                    )}
                                                                    <MenuItem
                                                                        onClick={() => archiveHandler()}
                                                                        sx={{ ...archivingMenuItem, color: 'error.main' }}
                                                                    >
                                                                        <Iconify icon={'eva:archive-fill'} sx={{ mr: 1 }} />
                                                                        {leadDetail?.is_archive_pending ? 'Archiving' : 'Archive lead'}
                                                                    </MenuItem>
                                                                    <MenuItem
                                                                        onClick={() => { setOpen(false); setSpamConfirmOpen(true); }}
                                                                        sx={{ ...archivingMenuItem, color: 'error.main' }}
                                                                    >
                                                                        <Iconify icon={'ic:baseline-report'} sx={{ mr: 1 }} />
                                                                        Mark as Spam
                                                                    </MenuItem>
                                                                    {isSuperuser && (
                                                                      <>
                                                                        <Divider sx={{ borderStyle: 'dashed' }} />
                                                                        <MenuItem
                                                                            data-testid="lead-detail-backfill-menu-item"
                                                                            onClick={() => { setOpen(false); setBackfillPreviewOpen(true); }}
                                                                            sx={editDetailMenuItem}
                                                                        >
                                                                            <Iconify icon={'bx:wrench'} sx={{ mr: 1 }} />
                                                                            Backfill
                                                                        </MenuItem>
                                                                      </>
                                                                    )}
                                                                </MenuList>
                                                            </ClickAwayListener>
                                                        </Paper>
                                                    </Grow>
                                                )}
                                            </Popper>
                                        </Box>
                                    </Box>
                                    <Box sx={commHubWrapper}>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <IconButton
                                                onClick={() => handleTabs('', 'All communications', '', '', '', true)}
                                                sx={commHubButton}
                                            >
                                                <Iconify icon={'ic:outline-whatsapp'} width={22} height={22} sx={{ color: '#25D366' }} />
                                            </IconButton>
                                            <Typography sx={{ fontSize: '10px', color: 'grey.500', mt: 0.25 }}>WhatsApp</Typography>
                                        </Box>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <IconButton
                                                onClick={() => handleTabs('', 'All communications', '', '', '', false, true)}
                                                sx={commHubButton}
                                            >
                                                <Tooltip title={leadDetail?.is_unsubscribed ? 'Unsubscribed' : ''}>
                                                    <Iconify
                                                        icon={leadDetail?.is_unsubscribed ? 'mdi:email-lock-outline' : 'ic:outline-email'}
                                                        width={22}
                                                        height={22}
                                                        sx={{ color: leadDetail?.is_unsubscribed ? 'common.red' : '#637381' }}
                                                    />
                                                </Tooltip>
                                            </IconButton>
                                            <Typography sx={{ fontSize: '10px', color: 'grey.500', mt: 0.25 }}>Email</Typography>
                                        </Box>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <IconButton
                                                onClick={() => {
                                                    setOptions('phoneNumber');
                                                    onChangeTab('', 'Overview');
                                                    setOpenContactFromCall(true);
                                                }}
                                                sx={commHubButton}
                                            >
                                                <Iconify icon={'eva:phone-outline'} width={22} height={22} sx={{ color: '#637381' }} />
                                            </IconButton>
                                            <Typography sx={{ fontSize: '10px', color: 'grey.500', mt: 0.25 }}>Phone</Typography>
                                        </Box>
                                        <LeadPageCallButton
                                            to={leadDetail?.lead_contact?.phone || ''}
                                            leadId={leadDetail?.id}
                                            buttonSx={commHubButton}
                                            phoneCheck={leadDetail?.phone_check}
                                        />
                                        {hasConsultationRecording && (
                                            <Box sx={{ textAlign: 'center' }}>
                                                <IconButton
                                                    onClick={() => handleTabs('', 'Consultations')}
                                                    sx={commHubButton}
                                                >
                                                    <Iconify icon={'solar:microphone-2-bold'} width={22} height={22} sx={{ color: '#637381' }} />
                                                </IconButton>
                                                <Typography sx={{ fontSize: '10px', color: 'grey.500', mt: 0.25 }}>Record</Typography>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>

                                {/* Row 1b: Created date + Treatment chips */}
                                {(leadDetail?.created_at || (leadDetail?.lead_treatments || []).some((t) => t.treatment)) && (
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        sx={{ mt: -1, mb: 1.5, flexWrap: 'wrap', gap: 0.75 }}
                                    >
                                        {leadDetail?.created_at && (
                                            <Typography sx={{ fontSize: '12px', color: 'text.secondary', lineHeight: 1.4 }}>
                                                {(() => { const m = moment(leadDetail.created_at, 'DD-MM-YYYY HH:mm:ss'); return m.isValid() ? `Created ${m.format('DD MMMM YYYY')}` : null; })()}
                                            </Typography>
                                        )}
                                        {(leadDetail?.lead_treatments || []).filter((t) => t.treatment).map((t) => (
                                            <Chip
                                                key={t.id}
                                                label={t.treatment}
                                                size="small"
                                                sx={{
                                                    height: 20,
                                                    fontSize: '0.68rem',
                                                    bgcolor: 'action.hover',
                                                    color: 'text.secondary',
                                                    '& .MuiChip-label': { px: 0.75 },
                                                }}
                                            />
                                        ))}
                                    </Stack>
                                )}

                                {/* Row 2: Status Lifecycle Bar */}
                                <Box sx={lifecycleBarWrapper}>
                                    {JOURNEY_STAGES.map((stage, idx) => {
                                        const currentStageIdx = getStageIndex(getMostAdvancedStatus(leadDetail?.lead_treatments));
                                        const isFTA = leadDetail?.lead_treatments?.some((t) => t.status === 'FAILED_TO_ATTEND_CONSULTATION');
                                        const isCompleted = idx < currentStageIdx;
                                        const isActive = idx === currentStageIdx;
                                        const dotColor = (isFTA && idx === 1) ? '#FF5630' : stage.color;
                                        return (
                                            <Box key={stage.value} sx={{ display: 'flex', alignItems: 'center', flex: idx < JOURNEY_STAGES.length - 1 ? 1 : 'none' }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                    <Box sx={lifecycleDot(isActive, isCompleted, dotColor)}>
                                                        <Iconify
                                                            icon={isCompleted ? 'material-symbols:check-small-rounded' : stage.icon}
                                                            width={isActive ? 18 : 14}
                                                            height={isActive ? 18 : 14}
                                                        />
                                                    </Box>
                                                    <Typography sx={lifecycleLabel(isActive)}>
                                                        {(isFTA && idx === 1) ? 'FTA' : stage.label}
                                                    </Typography>
                                                </Box>
                                                {idx < JOURNEY_STAGES.length - 1 && (
                                                    <Box sx={lifecycleConnector(isCompleted, stage.color)} />
                                                )}
                                            </Box>
                                        );
                                    })}
                                </Box>

                                {/* Row 3: Metadata Pill Badges */}
                                <Box sx={metadataRow}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Box sx={pillBadge('rgba(24, 144, 255, 0.08)', '#1890FF')}>
                                            <Iconify icon={'mdi:phone-check-outline'} width={16} height={16} />
                                            {(() => {
                                                // Single source of truth: LeadContactedCount on the
                                                // active treatment, matching the action-button count and
                                                // New/Follow-up sub-tabs (all read lead_contacted_counts).
                                                // leadDetail is refreshed via followUpSlice whenever
                                                // lead-tasks-v2-changed fires (checklist completion) or
                                                // on any note/action that previously triggered a reload.
                                                const treatment = selectedTreatment;
                                                const attempts = treatment
                                                    ? (treatment.lead_contacted_counts?.find(
                                                        (item) => item.status === treatment.status
                                                    )?.count || 0)
                                                    : 0;
                                                return `${attempts} contact ${attempts === 1 ? 'attempt' : 'attempts'}`;
                                            })()}
                                        </Box>
                                        {/* The stored number can't be dialled (CU-869fnwgxf): server's phone_check. */}
                                        {phoneProblem(leadDetail?.phone_check) && (
                                            <Tooltip title={phoneProblem(leadDetail?.phone_check)}>
                                                <Box
                                                    sx={pillBadge(warning.lighter, warning.dark)}
                                                    data-testid="lead-phone-warning"
                                                    aria-label={`${PHONE_BADGE_TEXT}. ${phoneProblem(leadDetail?.phone_check)}`}
                                                >
                                                    <Iconify icon={'mdi:phone-alert-outline'} width={16} height={16} />
                                                    {PHONE_BADGE_TEXT}
                                                </Box>
                                            </Tooltip>
                                        )}
                                        {/* "Why is this lead in <status>?" explainer — sits directly
                                            beside the contact-attempts chip. */}
                                        <LeadBucketExplainer leadDetail={leadDetail} leadNotes={leadNotes} />
                                        {/* Dentally patient link — identity only; booking sync is a separate fact.
                                            Rendered only for the route practice's active integration with view access. */}
                                        {dentallyScope.visible && (
                                            <DentallyPatientLinkChip
                                                outcome={dentallyPatientLink.isLoading ? 'loading' : dentallyPatientLink.outcome}
                                                patientId={dentallyPatientLink.link?.dentally_patient_id}
                                                onClick={() => handleTabs('', 'Personal details')}
                                            />
                                        )}
                                        {/* Async recheck found a possible Dentally patient for an unlinked lead. */}
                                        {dentallyScope.visible && dentallyPatientLink.outcome === 'none' && (
                                            <DentallyPossibleMatchBadge
                                                practiceId={practiceId}
                                                leadId={leadDetail?.id}
                                                candidates={getDentallyPossibleMatch(leadDetail)}
                                                onLinked={dentallyPatientLink.refresh}
                                            />
                                        )}
                                        {/* Next active booking of the selected treatment, with its provider state.
                                            A separate fact from the patient link; click opens that exact appointment. */}
                                        {dentallyScope.visible && (
                                            <DentallyNextBookingChip
                                                appointment={nextTreatmentBooking.next}
                                                others={nextTreatmentBooking.others}
                                                treatmentName={selectedTreatment?.treatment}
                                                onClick={() => openTreatmentAppointment(selectedTreatment?.id, nextTreatmentBooking.next?.id)}
                                            />
                                        )}
                                        {/* Resource referral pill (with hover tooltip explaining what
                                            it refers to). Leading icon on the Overview enquiry card was
                                            removed so the referral lives only here. */}
                                        {leadDetail && leadDetail.lead_source && leadDetail.lead_source.referral && referral?.map((e1) => {
                                            if (leadDetail.lead_source.referral === e1.value) {
                                                return (
                                                    <Tooltip
                                                        key={e1.value}
                                                        title={`Resource referral: ${e1.label}${leadDetail.lead_source?.metadata?.referral_detail ? ` · ${leadDetail.lead_source.metadata.referral_detail}` : ''}`}
                                                        placement='bottom'
                                                        TransitionComponent={Zoom}
                                                        TransitionProps={{ timeout: 300 }}
                                                    >
                                                        <Box sx={pillBadge('rgba(145, 158, 171, 0.08)', '#637381')}>
                                                            <Iconify icon={e1.icon} width={16} height={16} />
                                                            {e1.label}{leadDetail.lead_source?.metadata?.referral_detail ? ` · ${leadDetail.lead_source.metadata.referral_detail}` : ''}
                                                        </Box>
                                                    </Tooltip>
                                                );
                                            }
                                            return null;
                                        })}
                                    </Box>
                                    <Box
                                        sx={{ ...pillBadge('rgba(0, 167, 111, 0.08)', '#00A76F'), cursor: 'pointer' }}
                                        onClick={(e) => OpenAssignTask(leadDetail, e)}
                                    >
                                        {assigneeData?.length > 0 ? (
                                            <>
                                                <AssignUserAvatar
                                                    sx={{ height: '20px', width: '20px', fontSize: '10px' }}
                                                    src={assigneeData?.[0]?.user?.avatar || ''}
                                                    name={`${assigneeData?.[0]?.user?.first_name || ''} ${assigneeData?.[0]?.user?.last_name || ''}`}
                                                    role={assigneeData?.[0]?.role}
                                                />
                                                <Tooltip
                                                    title={getAssignees(leadDetail)}
                                                    placement='bottom'
                                                    TransitionComponent={Zoom}
                                                    TransitionProps={{ timeout: 300 }}
                                                >
                                                    <span>
                                                        {`${capitalizeFirstLetter(assigneeData?.[0]?.user?.first_name) || ''} ${capitalizeFirstLetter(assigneeData?.[0]?.user?.last_name) || ''}`}
                                                        {leadDetail?.assignees?.length > 1 ? ` +${leadDetail?.assignees?.length - 1}` : ''}
                                                    </span>
                                                </Tooltip>
                                            </>
                                        ) : (
                                            <>
                                                <Iconify icon={'eva:plus-fill'} width={16} height={16} />
                                                Unassigned
                                            </>
                                        )}
                                    </Box>
                                    {/* Polish C — form-state summary chip.
                                        Hidden when the lead has zero consent
                                        requests. Click jumps to the Forms tab
                                        (existing tab in TABS array, line 568)
                                        via the same handleTabs/?tab= flow used
                                        by every other navigation here. */}
                                    {formChipSummary && (
                                        <Tooltip title={formChipSummary.tooltip} placement='bottom'>
                                            <Box
                                                onClick={() => handleTabs('', 'Forms')}
                                                sx={{ ...pillBadge(formChipSummary.bg, formChipSummary.fg), cursor: 'pointer' }}
                                            >
                                                <Iconify icon={'mdi:file-document-outline'} width={16} height={16} />
                                                {formChipSummary.label}
                                            </Box>
                                        </Tooltip>
                                    )}
                                    {Array.isArray(leadTags) && leadTags.map((t) => (
                                        <Box
                                            key={t.id}
                                            sx={{
                                                ...pillBadge(
                                                    t?.colour ? `${t.colour}1F` : 'rgba(145, 158, 171, 0.12)',
                                                    t?.colour || '#454F5B'
                                                ),
                                            }}
                                            title={t?.name}
                                        >
                                            {t?.name}
                                        </Box>
                                    ))}
                                    <Box
                                        sx={{
                                            ...pillBadge('rgba(145, 158, 171, 0.08)', '#637381'),
                                            cursor: 'pointer',
                                            justifyContent: 'center',
                                        }}
                                        onClick={(e) => setTagPopoverAnchor(e.currentTarget)}
                                    >
                                        <Iconify icon={'eva:plus-fill'} width={16} height={16} />
                                        Add tags
                                    </Box>
                                    {/* Pinned leads: archived leads can't be pinned (the API never returns them). */}
                                    {leadDetail && !leadDetail.is_archived && (
                                        <LeadPinControl leadId={leadDetail.id} variant="pill" />
                                    )}
                                    <Popover
                                        open={Boolean(tagPopoverAnchor)}
                                        anchorEl={tagPopoverAnchor}
                                        onClose={() => setTagPopoverAnchor(null)}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{ sx: { p: 1.5, width: 320, mt: 0.5 } }}
                                        TransitionProps={{
                                            onEntered: () => {
                                                const input = tagPopoverContentRef.current?.querySelector('input');
                                                if (input) {
                                                    input.focus();
                                                    input.click();
                                                }
                                            },
                                        }}
                                    >
                                        <Box ref={tagPopoverContentRef}>
                                            <FormControl sx={{ width: '100%' }} value={value}>
                                                <AutocompleteTags type={'leadDetail'} />
                                            </FormControl>
                                        </Box>
                                    </Popover>
                                </Box>

                                {/* Tabs (unchanged) */}
                                <Tabs
                                    variant='scrollable'
                                    scrollButtons
                                    allowScrollButtonsMobile
                                    value={currentTab}
                                    onChange={handleTabs}
                                    sx={{ boxShadow: `0px 1px 0px 0px ${primary.paperColor} inset`, '.MuiTabs-indicator': { bgcolor: 'primary.main' } }}
                                >
                                    {TABS.map((tab, index) => (
                                        <Tab
                                            disableRipple
                                            key={index}
                                            label={isMobileDetail ? labelCount({ ...tab, displayValue: getMobileLabel(tab.value) }) : labelCount(tab)}
                                            value={tab.value}
                                            sx={{
                                                mr: { xs: '8px !important', sm: '24px !important' },
                                                textTransform: 'none !important',
                                                minWidth: { xs: 'auto' },
                                                fontSize: { xs: '12px', sm: '14px' },
                                            }}
                                        />
                                    ))}
                                </Tabs>
                            </Card>
                            <Grid item xs={12} md={12} sx={{ mt: 2 }}>
                                {TABS.map((tab) => {
                                    const isMatched = tab.value === currentTab;
                                    return (
                                        isMatched && (
                                            <Box key={tab.value}>
                                                <NormalLoading
                                                    type={'LeadDetails'}
                                                    tableData={(!loaderValue || loaderData) && 'No Found'}
                                                    pageCount={(!loaderValue || loaderData) && 'No Found'}
                                                />
                                                {tab.component}
                                            </Box>
                                        )
                                    );
                                })}
                            </Grid>
                        </Grid>
                        <Box onClick={handleChoose} sx={iconBox}>
                            <IconButton color='primary' component='label' sx={iconBtn}>
                                <Iconify icon={'eva:plus-fill'} color={'common.white'} height={'35px'} width={'35px'} />
                            </IconButton>
                        </Box>
                    </>
                )}
            </Container>
            <Dialog open={spamConfirmOpen} onClose={() => setSpamConfirmOpen(false)}>
                <DialogTitle>
                    Mark {leadDetail ? `${leadDetail.first_name || ''} ${leadDetail.last_name || ''}`.trim() : 'this lead'} as spam? This lead will be removed from all counts and reports.
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => setSpamConfirmOpen(false)} color='inherit'>
                        Cancel
                    </Button>
                    <Button onClick={handleMarkAsSpamConfirm} variant='contained' color='error'>
                        Mark as Spam
                    </Button>
                </DialogActions>
            </Dialog>
            {isSuperuser && backfillPreviewOpen && (
                <BackfillPreviewModal
                    open={backfillPreviewOpen}
                    onClose={() => setBackfillPreviewOpen(false)}
                    leadId={leadDetail?.id}
                />
            )}
            {transferOpen && (
                <TransferLeadDialog
                    open
                    onClose={() => setTransferOpen(false)}
                    leadId={leadDetail?.id}
                    practiceId={practiceId}
                    leadName={`${leadDetail?.first_name || ''} ${leadDetail?.last_name || ''}`.trim()}
                    onDone={handleTransferDone}
                />
            )}
            {openArchiveLead && (
                <ArchivedLeadPopUp
                    open={openArchiveLead}
                    headerButtons
                    onClose={onCloseArchiveLead}
                    user={leadData}
                    type={'archiveLead'}
                    inputRef={inputRef}
                    CreateLeadHeaderData={CreateLeadHeaderData}
                    onExplicitArchiveSubmit={handleExplicitArchiveSubmit}
                />
            )}
            {leadDetailModal && (
                <EditDialogPopup
                    open={leadDetailModal}
                    onClose={closeEditDetails}
                    steps={leadStep}
                    type={'editLead'}
                    validStep={validStep}
                    updateStep={(type) => setValidStep(type)}
                    inputRef={inputRef}
                    title='Edit Details'
                    headerButtons
                />
            )}
            {templateOpen && (
                <LeadTemplate
                    openEmailCompose={Boolean(templateOpen)}
                    onCloseEmailCompose={() => closeEmailCompose()}
                    practiceId={practiceId}
                    type={'EMAIL'}
                    leadDetail={leadDetail}
                />
            )}
            {Payment && (
                <OpenPayment open={Payment} onClose={handleClosePayment} headerButtons user={leadDetail} inputRef={inputRef} />
            )}
            <AddReminderPopup
                open={openReminder}
                onClose={onCloseReminder}
                leadDetail={leadDetail}
                type={'addTask'}
                reloadTaskCounter
                reload
                page={'LeadDetail'}
                handleLoading={handleLoading}
            />
            {v1Enabled && (
                <ConsentBuilderPopUp open={ConsentBuilder} onClose={onCloseConsent} Users={leadDetail} type={'LeadDetail'} />
            )}
            {v2Enabled && (
                <SendFormsDialog
                    open={consentV2Open}
                    onClose={() => setConsentV2Open(false)}
                    practiceId={practiceId}
                    initialLead={leadDetail}
                />
            )}
            <SwitchUserPopup open={openAssignTask} onClose={handleCloseNotes} Users={leadDetail} type={'LeadDetail'} />
            {openNotePopup && (
                <AddNotePopup
                    open={openNotePopup}
                    onClose={handleCloseNotePopup}
                    Users={leadDetail}
                    type={'LeadDetail'}
                    options={options}
                    setTemplateOpen={setTemplateOpen}
                    templateOpen={templateOpen}
                />
            )}
            {openAssignToTask && (
                <ClickAwayListener onClickAway={onClickAwayEvent}>
                    <Popper open={openAssignToTask} anchorEl={anchorElAssign} transition placement='bottom' sx={{ zIndex: '999999' }}>
                        {({ TransitionProps }) => (
                            <Grow {...TransitionProps}>
                                <Paper sx={{ borderRadius: 2 }}>
                                    <AssignTaskPopup
                                        open={openAssignToTask}
                                        onClose={() => {
                                            onCloseAssignTaskPopup();
                                            setAnchorElAssign(null);
                                        }}
                                        leadId={selectedRowId}
                                        type={'leadAssign'}
                                        leadDetail={leadDetail}
                                        assignees={assigneeData?.map((ele) => ele.id)}
                                    />
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                </ClickAwayListener>
            )}
            <Popper
                sx={poperStyle}
                open={openPlusBtn}
                anchorEl={anchorEl}
                role={undefined}
                transition
                placement={'top-start'}
            >
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={buttonHandleClose}>
                                <MenuList id='split-button-menu' autoFocusItem sx={paperMenuList}>
                                    {plusBtnPoper.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            onClick={() => handleMenuItems(option.value)}
                                            sx={{ ...paperMenuItem2, display: option.show }}
                                        >
                                            <Iconify style={{ marginRight: '12px' }} width={24} height={24} icon={option.icon} />
                                            <Box sx={paperBox}>
                                                {option.value}
                                                <Typography sx={{ fontSize: '12px', fontWeight: '400' }}>{option.subject}</Typography>
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </DentallyLeadProvider>
    );
}

LeadDetailViewBodyInner.propTypes = {
    /** Lead id — passed by the parent (panel or page wrapper). */
    leadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    /** Practice id — passed by the parent (panel or page wrapper). */
    practiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    /** When true: hides Helmet + HeaderBreadcrumbs; not-found redirects become no-ops. */
    embedded: PropTypes.bool,
    /** Called when leadDetailNotFound fires (page route: navigate away; panel: close panel). */
    onNotFound: PropTypes.func,
    /** The `state` object from the router location (page: from useLocation; panel: null). */
    locationState: PropTypes.object,
    /** The `search` string from the router location for ?tab= deep-linking (panel: null). */
    locationSearch: PropTypes.string,
};

LeadDetailViewBodyInner.defaultProps = {
    embedded: false,
    onNotFound: null,
    locationState: null,
    locationSearch: null,
};

// Thin wrapper that owns the ActiveTreatmentProvider so LeadDetailViewBodyInner
// (and every consumer below it) can call useActiveTreatment(). A component cannot
// consume a context it renders, hence the split. `leadDetail` is not a prop — it
// lives in Redux (state.lead.leadDetail) — so we read it here to feed the provider.
function LeadDetailViewBody(props) {
    const leadDetail = useSelector((state) => state.lead.leadDetail);
    return (
        <ActiveTreatmentProvider leadDetail={leadDetail}>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <LeadDetailViewBodyInner {...props} />
        </ActiveTreatmentProvider>
    );
}

export default LeadDetailViewBody;
